import React, { useState, useEffect } from 'react';
import { Smile, Edit3, Target, X, Save, BookOpen } from 'lucide-react';
import { db } from '../firebase';
import { query, collection, where, onSnapshot, getDocs } from 'firebase/firestore';

const MOTIVATION_QUOTES = [
  "Başarı, her gün tekrarlanan küçük çabaların toplamıdır.",
  "Gelecek, bugünden ona hazırlananlara aittir.",
  "Dağ ne kadar yüce olsa da yol üstünden aşar.",
  "Hata yapmaktan korkma, denememekten kork.",
  "Kendine inan, başarının yarısı budur."
];

const StudentDashboard = ({ user }) => {
  const [studentName, setStudentName] = useState(null);
  const quote = MOTIVATION_QUOTES[Math.floor(Math.random() * MOTIVATION_QUOTES.length)]; 

  // Öğrencinin İsmini Çekme (YENİ AKILLI ARAMA - STREAM ÇÖKMESİNE KARŞI KORUMALI)
  useEffect(() => {
    const fetchStudentName = async () => {
      if (!user || (!user.clinicianUid && !user.clinicianCode)) return;
      
      const searchField = user.clinicianUid ? "clinicianUid" : "clinicianCode";
      const searchValue = user.clinicianUid || String(user.clinicianCode);

      try {
        // 🛡️ DİKKAT: onSnapshot (canlı dinleme) yerine getDocs kullanıyoruz. 
        // Çünkü canlı dinleyici React'ın hızlı yüklenmelerinde "Stream Assertion" hatasına sebep oluyor.
        const q = query(collection(db, "classes"), where(searchField, "==", searchValue));
        const querySnapshot = await getDocs(q);
        
        const myClasses = querySnapshot.docs.map(doc => doc.data());
        let foundName = null;
        
        for (let cls of myClasses) {
          if (cls.students && Array.isArray(cls.students)) {
             const student = cls.students.find(s => String(s.no).trim() === String(user.no).trim());
             if (student) {
                foundName = student.name;
                break; 
             }
          }
        }
        if (foundName) setStudentName(foundName);
      } catch (err) {
        console.error("İsim çekme hatası:", err);
      }
    };

    fetchStudentName();
  }, [user]);

 return (
    <div className="space-y-8 no-print">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-[2.5rem] p-10 text-white shadow-xl shadow-blue-900/20 relative overflow-hidden">
        <div className="relative z-10">
          <h2 className="text-4xl font-black mb-4">
            Merhaba, {user.fullName || studentName || user.no}! 👋
          </h2>
          <p className="text-blue-100 text-lg max-w-2xl font-medium">
            Bugün geleceğin için harika bir gün. Kendine inan ve harekete geç.
          </p>
        </div>
        <div className="absolute right-0 top-0 h-full w-1/3 bg-white/10 skew-x-12 transform translate-x-12"></div>
      </div>
      
     <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col items-center text-center mt-8">
        <div className="h-16 w-16 bg-amber-100 rounded-full flex items-center justify-center text-amber-500 mb-6"><Smile className="h-8 w-8"/></div>
        <h3 className="text-xl font-bold text-slate-800 mb-2">Günün Motivasyon Sözü</h3>
        <p className="text-slate-600 italic text-lg">"{quote}"</p>
      </div>
    </div>
  ); 
};

export default StudentDashboard;